import React, { createContext, useState, useEffect, useContext } from 'react';
import { getAdminAnalytics } from '../services/analyticsService';

export const AnalyticsContext = createContext();

export const AnalyticsProvider = ({ children }) => {
  const [analytics, setAnalytics] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dateFilters, setDateFilters] = useState({});

  useEffect(() => {
    const fetchAnalytics = async () => {
      setLoading(true);
      try {
        const data = await getAdminAnalytics(dateFilters);
        setAnalytics(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching analytics:', error);
        setError('Failed to fetch analytics data.');
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [dateFilters]);

  const incrementData = (key) => {
    setAnalytics((prevAnalytics) => ({
      ...prevAnalytics,
      [key]: prevAnalytics[key] + 1,
    }));
  };

  const decrementData = (key) => {
    setAnalytics((prevAnalytics) => ({
      ...prevAnalytics,
      [key]: prevAnalytics[key] - 1,
    }));
  };

  return (
    <AnalyticsContext.Provider value={{ analytics, loading, error, incrementData, decrementData, dateFilters, setDateFilters }}>
      {loading && Object.keys(analytics).length === 0 ? (
        <div className="flex items-center justify-center h-screen">
          <span className="loading loading-dots loading-lg"></span>
        </div>
      ) : error && Object.keys(analytics).length === 0 ? (
        <div className="flex items-center justify-center h-screen">
          <p className="text-red-500">{error}</p>
        </div>
      ) : (
        children
      )}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => useContext(AnalyticsContext);
